module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-11.6abfc4b2.png";